import { render, staticRenderFns } from "./CancelBookingAction.vue?vue&type=template&id=48e6b3e3"
import script from "./CancelBookingAction.vue?vue&type=script&lang=js"
export * from "./CancelBookingAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports